module.exports = __webpack_public_path__ + "img/ru_failure_3.cb87d72f.png";